import { css } from '@emotion/react';

import { COLORS2 } from '@/Client/Styles';

const TRACK_STYLE = css`
  label: PROGRESS_BAR_TRACK_STYLE;
  align-self: stretch;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
`;

const FILL_STYLE = css`
  label: PROGRESS_BAR_FILL_STYLE;
  height: 100%;
  border-radius: 4px;
`;

export const ProgressBar = ({
  progress,
  filledColor = COLORS2.namedColors.yellow,
  emptyColor = COLORS2.namedColors.lightestGray,
}: {
  progress: number;
  filledColor?: string;
  emptyColor?: string;
}) => (
  <div css={TRACK_STYLE} style={{ backgroundColor: emptyColor }}>
    {progress > 0 && <div css={FILL_STYLE} style={{ width: `${Math.round(progress * 100)}%`, backgroundColor: filledColor }} />}
  </div>
);
